import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  centerLoader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  }
})

export default useStyles
